import { Alert } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectors as selectorsLogin } from '../../../LoginPage/reducer';
import * as Styled from './WarningBlock.styles';

export function WarningBlock() {
  const dataUser = useSelector(selectorsLogin.userData);

  const networks = (process.env.REACT_APP_LOYALTY_MAINTENANCE_NETWORKS ?? '')
    .split(',')
    .map((n) => n.trim())
    .filter(Boolean);

  if (!networks.length || !dataUser?.networkCode) {
    return null;
  }

  if (!networks.includes(dataUser.networkCode)) {
    return null;
  }

  return (
    <Styled.WarningContainer>
      <Alert severity="warning" variant="filled">
        Сервис ПЛ временно отключен - ведутся технические работы
      </Alert>
    </Styled.WarningContainer>
  );
}
